import { ResponsiveCard } from '../../molecules/card/Card';

interface IOsasFaqCardProps {
    lg?: number;
}

export function OsasFaqCard(props: Readonly<IOsasFaqCardProps>) {
    const linkTo = `/osasFaqs`;

    return (
        <ResponsiveCard
            body="Heb je een vraag? Zie hier de antwoorden op veelgestelde vragen"
            cardTitle="Veelgestelde vragen"
            lg={props.lg}
            linksText={['Open veelgestelde vragen']}
            linksTo={[linkTo]}
        />
    );
}
